import React, { useMemo } from 'react';
import Checkbox from '../../../../common/Form/Checkbox';
import IconToolTip from '../../../../common/IconToolTip';
import Warehouse from '../../../../components/Inputs/Warehouse';
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';
import { actualValueForDropdown, validateStringValue, ScogoID, scogo_repair_center } from '../../../../utils/common';
import { useFormContext } from 'react-hook-form';
import { textCss } from '../../../../common/Css';
import Input from '../../../../common/Form/Input';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { changeServieRequestWarehouse } from '../../../../actions/inventory';
import RepairCenter from '../../../../components/Inputs/RepairCenter';

const change_warehouse_details = 'change_warehouse_details';

export const CurrentWarehouseDetail = ({ isLoading, serviceRequest, currentMilestone, isLoggedUserIsScmOrCustomer, isWarehousePrefillAndIsDisabled, isFaultyDeviveShipToPrefillAndIsDisabled }) => {
    const { watch } = useFormContext();
    const dispatch_location_id = watch('dispatch_location_id');
    const receive_location_id = watch('received_location_id');
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const dispatch = useDispatch();

    const onChangeWarehouse = () => {
        dispatch(changeServieRequestWarehouse({
            formName: change_warehouse_details, payload: {
                ticket_id: serviceRequest.id,
                milestone_id: currentMilestone.id,
                dispatch_location_id: actualValueForDropdown(dispatch_location_id),
                received_location_id: actualValueForDropdown(receive_location_id)
            }
        }));
    }

    const isSaveButtonDisabled = useMemo(() => {
        if (!actualValueForDropdown(receive_location_id) && !actualValueForDropdown(dispatch_location_id)) return true;
        return (currentMilestone.dispatch_location_id === actualValueForDropdown(dispatch_location_id)) && (currentMilestone.receive_location_id === actualValueForDropdown(receive_location_id))
    }, [dispatch_location_id, receive_location_id, currentMilestone]);

    const selectedDispatchLocation = useMemo(() => {
        if (currentMilestone?.dispatch_location?.id) {
            return {
                label: currentMilestone?.dispatch_location?.external_id,
                value: currentMilestone?.dispatch_location?.id,
                key: currentMilestone?.dispatch_location?.id,
                location: {
                    address: currentMilestone?.dispatch_location?.address
                }
            }
        }
        return null;
    }, [currentMilestone?.dispatch_location?.id]);

    const selectedReceiveLocation = useMemo(() => {
        if (currentMilestone?.receive_location?.id) {
            return {
                label: currentMilestone?.receive_location?.external_id,
                value: currentMilestone?.receive_location?.id,
                key: currentMilestone?.receive_location?.id,
                location: {
                    address: currentMilestone?.receive_location?.address
                }
            }
        }
        return null;
    }, [currentMilestone?.receive_location?.id]);

    const getDetails = () => {
        if (isLoading || Object.keys(currentMilestone).length === 0) {
            return (
                <div className='h-full'>
                    <SkeltonCardTwo arr={[1, 2, 3]} height={15} className={''} padding={1} />
                </div>
            );
        }

        return (
            <div>
                <div className='flex'>
                    <div className='w-6/12'>
                        {isWarehousePrefillAndIsDisabled ? <Input shouldUnregister name='dispatch_location_id_field' label='Warehouse' readOnly className='w-full' /> :
                            <Warehouse org_check_required={isLoggedUserIsScmOrCustomer} prefillObj={selectedDispatchLocation} className='w-full' label='Warehouse' name='dispatch_location_id' org_id={serviceRequest.org_id} />}

                        <div className='w-[95%] px-2 shadow-md bg-slate-50 rounded-md py-1 mx-auto'>
                            <p className={textCss?.detailsTitle}>Address</p>
                            <IconToolTip title={`Title : ${validateStringValue(dispatch_location_id?.location?.address)}`}>
                                <p className={`${textCss?.detailsValue} line-clamp-1 break-all`}>{`${validateStringValue(dispatch_location_id?.location?.address)}`}</p>
                            </IconToolTip>
                        </div>
                    </div>
                    <div className='w-6/12'>
                        {isFaultyDeviveShipToPrefillAndIsDisabled ?
                            <Input shouldUnregister name='received_location_id_field' label='Ship Faulty Device To' readOnly className='w-full' />
                            : <RepairCenter
                                org_id={serviceRequest.org_id}
                                shouldUnregister
                                className='w-full'
                                label='Ship Faulty Device To'
                                name='received_location_id'
                                org_check_required={isLoggedUserIsScmOrCustomer}
                                readOnly={!isLoggedUserIsScmOrCustomer && currentMilestone?.receive_location_id}
                                prefillObj={selectedReceiveLocation}
                                prefill={!selectedReceiveLocation && serviceRequest?.helpdesk_id === ScogoID ? [scogo_repair_center] : []}
                            />}

                        <div className='w-[95%] mx-auto px-2 shadow-md bg-slate-50 rounded-md py-1'>
                            <p className={textCss?.detailsTitle}>Address</p>
                            <IconToolTip title={`Title : ${validateStringValue(receive_location_id?.location?.address)}`}>
                                <p className={`${textCss?.detailsValue} line-clamp-1 break-all`}>{`${validateStringValue(receive_location_id?.location?.address)}`}</p>
                            </IconToolTip>
                        </div>
                    </div>
                </div>
                <div className='flex gap-2'>
                    <label className='flex items-center justify-between'>
                        <span className='pt-2'>
                            <Checkbox id={'release_vendor'} label='Do you want to remove current service partner/field engineer of this RMA request' name='release_vendor' type={'checkbox'} />
                        </span>
                    </label>
                    <div className='flex ml-auto'>
                        <div className='w-full pt-2'> <button
                            type="button"
                            className={`flex items-center gap-1 px-3 py-2 rounded-md transition-colors shadow-md ${(isSaveButtonDisabled || formButtonLoading[change_warehouse_details]) ? ' opacity-80 bg-gray-200 text-orange-700 cursor-not-allowed' : 'bg-orange-200 text-orange-700 hover:bg-orange-200'}`}
                            onClick={onChangeWarehouse}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            disabled={isSaveButtonDisabled || formButtonLoading[change_warehouse_details]}
                        >
                            <span className="material-icons-outlined text-font11">inventory</span>
                            <span>Save</span>
                        </button></div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className='bg-white relative border-gray-200 shadow-lg w-full py-2 rounded-lg px-4'>
            <div className='ribbon w-3/4'>
                <span
                    className='ribbon3 bg-scogobgsky ribbonblue'
                    style={{
                        left: '-19px',
                    }}
                >
                    Current Warehouse Details
                </span>

            </div>
            <hr />
            <div className=''>{getDetails()}</div>
        </div>
    );
};
